import { Typography } from '@bgzt/ui';
import { Section, Spacing } from '~/components';
import { RankedKeywordItem } from '../RankedKeywordItem';

import styles from './RankedKeywords.module.css';
import { KeywordsRanking } from '~/apis/mercari/get-keywords-rankings';
import { getLatestUpdateTime } from '~/utils/get-ranked-keywords-latest-update-time';

type Props = {
  title?: string;
  rankedKeywords?: KeywordsRanking[];
  onKeywordClick?(value: KeywordsRanking, index?: number): void;
};

export const RankedKeywords = ({ title, rankedKeywords, onKeywordClick }: Props) => {
  if (!rankedKeywords || rankedKeywords?.length < 1) return null;

  return (
    <Section fullWidth>
      {title && (
        <>
          <h2 className={styles.title}>
            <Typography variant="S1" color="gray-900">
              {title}
            </Typography>
            <Typography variant="C4" color="gray-300">
              {getLatestUpdateTime() + ' 기준'}
            </Typography>
          </h2>
          <Spacing height={16} />
        </>
      )}

      <div className={styles.groups}>
        <ul className={styles.group}>
          {rankedKeywords.map((rankedKeyword, index) => (
            <RankedKeywordItem
              rankedKeyword={rankedKeyword}
              key={rankedKeyword.keyword}
              onClick={() => onKeywordClick?.(rankedKeyword, index)}
            />
          ))}
        </ul>
      </div>
    </Section>
  );
};
